module.exports = __webpack_public_path__ + "static/images/rich_text_editor/icons.png";